import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/checkout';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
}
export function CtaButton({
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-4 text-sm sm:text-base';
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex w-full items-center justify-center gap-3 rounded-xl bg-clay text-center font-semibold tracking-tight text-cream shadow-lift transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-clayDark focus:outline-none focus-visible:ring-2 focus-visible:ring-bark focus-visible:ring-offset-2 focus-visible:ring-offset-cream active:translate-y-0 sm:w-auto ${sizing} ${className}`} data-id="element-63" data-mp="qk251hb084ka">
      <span data-id="element-64" data-mp="15a9e56f4gb8b">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-65" data-mp="15b14o2tv3irq" />
    </a>;
}